import { Tooltip } from "antd";

import PublishBookedContractDurationIcon from "@/Components/Icons/PublishBookedContractDurationIcon";
import useRemainingTimeForBank from "@/utilities/hooks/useRemainingTimeForBank";

import useRemainingTimeForDays from "../../../../../utilities/hooks/useRemainingTimeForDays";

const LiveTimerTooltip = ({
  actionedAt,
  publisheddAt,
  cls = "text-blue",
  type = "",
  text = "",
}) => {
  const invitedRemainingTime = useRemainingTimeForDays(
    actionedAt,
    publisheddAt,
  );
  const bankRemainingTime = useRemainingTimeForBank(actionedAt, publisheddAt);
  const remainingTime =
    type == "invitedTimer" ? invitedRemainingTime : bankRemainingTime;

  // Determine the tooltip message based on conditions
  const tooltipMessage = () => {
    if (type == "invitedTimer") {
      return `Override compliance expires in ${remainingTime}`;
    } else if (remainingTime === "Expired") {
      return "Published to AppLocum Candidates";
    } else {
      return (
        <>
          Publish to AppLocum Candidates in <br /> {remainingTime}
        </>
      );
    }
  };

  return text == "candidate_details_compliance" ? (
    remainingTime !== "Expired" ? (
      <div className="rounded-lg bg-lightblueBG px-2 py-1 text-xs font-normal leading-[normal] text-black">
        Enabled for {remainingTime || "0 days"}
      </div>
    ) : null
  ) : (
    <Tooltip title={tooltipMessage()}>
      {remainingTime === "Expired" ? null : (
        <button className="flex items-center gap-1">
          <PublishBookedContractDurationIcon cls={cls} />
        </button>
      )}
    </Tooltip>
  );
};

export default LiveTimerTooltip;
